import React from "react";
import "../../stylesheet/components/collapse/Collapse.scss";

type CollapseItemProps = {
  title: string;
  handleClick: (item: string) => void;
  isActive: boolean;
};

const CollapseItemToggle: React.FC<CollapseItemProps> = ({
  title,
  handleClick,
  isActive,
}) => {
  const handleOnClick = () => {
    handleClick(title);
  };

  return (
    <div className="collapse-item" onClick={handleOnClick}>
      {isActive ? <div className="circle-selected-cursor" /> : null}
      {isActive ? (
        <p className="p2" style={{ fontWeight: "600" }}>
          {title}
        </p>
      ) : (
        <p className="p2">{title}</p>
      )}
    </div>
  );
};

export default CollapseItemToggle;
